export default __webpack_public_path__ + "static/media/arrow_left.8faa0a00.svg";